import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Options} from 'highcharts';
import {InsightsService} from "../../services/insights/insights.service";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-nps-overall',
  templateUrl: './nps-overall.component.pug',
  styleUrls: ['./nps-overall.component.scss'],
  standalone: false
})

export class NpsOverallComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() questionnaire!: any;
  @Input() filterBy!: any;
  @Input() pause_load = false;
  data = '-';

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService,private permissionsService: PermissionsService) {
  }

  ngOnInit(): void {
    }

  private loadAndSetData() {
    if(this.pause_load) {
      return;
    }
    this.insightsService.getNPSCategory(this.start, this.end, this.questionnaire, this.filterBy).subscribe(data => {
      let promoter = 0, detractor = 0;
      for (let d of data) {
        if (d['category'] === 'promoter') {
          promoter = d['nps']
        } else if (d['category'] === 'detractor') {
          detractor = d['nps']
        }
      }
      this.data = String(promoter - detractor);
    }, error => {
      console.log(error);
      this.data = '-';
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }
}
